/**
 * belfastpilates-production.appspot.com
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.3.1
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.BelfastpilatesProductionappspotcom) {
      root.BelfastpilatesProductionappspotcom = {};
    }
    root.BelfastpilatesProductionappspotcom.MigrateRequest = factory(root.BelfastpilatesProductionappspotcom.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The MigrateRequest model module.
   * @module model/MigrateRequest
   * @version 1.0.0
   */

  /**
   * Constructs a new <code>MigrateRequest</code>.
   * @alias module:model/MigrateRequest
   * @class
   */
  var exports = function() {
    var _this = this;











  };

  /**
   * Constructs a <code>MigrateRequest</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/MigrateRequest} obj Optional instance to populate.
   * @return {module:model/MigrateRequest} The populated <code>MigrateRequest</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('codeTag')) {
        obj['codeTag'] = ApiClient.convertToType(data['codeTag'], 'String');
      }
      if (data.hasOwnProperty('entityName')) {
        obj['entityName'] = ApiClient.convertToType(data['entityName'], 'String');
      }
      if (data.hasOwnProperty('fromType')) {
        obj['fromType'] = ApiClient.convertToType(data['fromType'], 'String');
      }
      if (data.hasOwnProperty('indexed')) {
        obj['indexed'] = ApiClient.convertToType(data['indexed'], 'Boolean');
      }
      if (data.hasOwnProperty('migrateType')) {
        obj['migrateType'] = ApiClient.convertToType(data['migrateType'], 'String');
      }
      if (data.hasOwnProperty('numberOfEntities')) {
        obj['numberOfEntities'] = ApiClient.convertToType(data['numberOfEntities'], 'Number');
      }
      if (data.hasOwnProperty('packageName')) {
        obj['packageName'] = ApiClient.convertToType(data['packageName'], 'String');
      }
      if (data.hasOwnProperty('startPosition')) {
        obj['startPosition'] = ApiClient.convertToType(data['startPosition'], 'Number');
      }
      if (data.hasOwnProperty('toType')) {
        obj['toType'] = ApiClient.convertToType(data['toType'], 'String');
      }
      if (data.hasOwnProperty('userId')) {
        obj['userId'] = ApiClient.convertToType(data['userId'], 'String');
      }
    }
    return obj;
  }

  /**
   * @member {String} codeTag
   */
  exports.prototype['codeTag'] = undefined;
  /**
   * @member {String} entityName
   */
  exports.prototype['entityName'] = undefined;
  /**
   * @member {String} fromType
   */
  exports.prototype['fromType'] = undefined;
  /**
   * @member {Boolean} indexed
   */
  exports.prototype['indexed'] = undefined;
  /**
   * @member {String} migrateType
   */
  exports.prototype['migrateType'] = undefined;
  /**
   * @member {Number} numberOfEntities
   */
  exports.prototype['numberOfEntities'] = undefined;
  /**
   * @member {String} packageName
   */
  exports.prototype['packageName'] = undefined;
  /**
   * @member {Number} startPosition
   */
  exports.prototype['startPosition'] = undefined;
  /**
   * @member {String} toType
   */
  exports.prototype['toType'] = undefined;
  /**
   * @member {String} userId
   */
  exports.prototype['userId'] = undefined;



  return exports;
}));





// WEBPACK FOOTER //
// ./clientLibsProduction/src/model/MigrateRequest.js